/**
 * LeaderboardOptInNotice
 *
 * Tells the user, truthfully, whether they take part in the leaderboard. The
 * opt-in is their persisted public-profile setting (profile public + authority
 * scores shown) plus their talent-discovery opt-in, enforced by the server — so this links to that setting rather
 * than offering a local toggle that would change nothing.
 */

import { Link } from 'react-router-dom';
import { LEADERBOARD_OPT_IN_SETTINGS_PATH } from '../../utils/leaderboard';

export interface LeaderboardOptInNoticeProps {
  /** true = opted in; false/null = not opted in (or not known yet). */
  isOptedIn: boolean | null;
  /** The user's rank when they are listed on the board. */
  currentUserRank: number | null;
}

export function LeaderboardOptInNotice({ isOptedIn, currentUserRank }: LeaderboardOptInNoticeProps) {
  if (isOptedIn === true) {
    return (
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 p-4 bg-primary-50 rounded-lg border border-primary-100">
        <p className="text-sm text-gray-700">
          {currentUserRank !== null
            ? `You're on the leaderboard at #${currentUserRank}.`
            : "You've opted in. You'll appear once you have enough scored practice sessions."}
        </p>
        <Link
          to={LEADERBOARD_OPT_IN_SETTINGS_PATH}
          className="text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          Manage visibility
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <p className="text-sm text-gray-700">
        You're not on the leaderboard. To take part, make your public profile public, show
        your authority scores, and opt in to talent discovery.
      </p>
      <Link
        to={LEADERBOARD_OPT_IN_SETTINGS_PATH}
        className="text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
      >
        Profile visibility settings
      </Link>
    </div>
  );
}
